// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-26T16:35:56.411Z
// Property: Highpoint Apartments (ID: 6767906449167358)
// Collections: 12 amenities, 8 floorplans (live), 32 photos, 35 POIs, 3 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167358",
  "property_external_id": "4059830",
  "property_zillow_url": "https://www.zillow.com/apartments/bellefontaine-oh/highpoint-apartments/5Xt4hJ/",
  "property_apartments_url": "https://www.apartments.com/highpoint-apartments-bellefontaine-oh/g78wnnw/",
  "property_google_business_url": "https://www.google.com/maps/place/Highpoint+Apartments/data=!4m2!3m1!1s0x0:0x9b0d1b7e86c969e6?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "58347924637",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "4059830",
  "property_status": null,
  "property_slug": "highpoint-apartments",
  "property_name": "Highpoint Apartments",
  "property_website_url": "https://www.highpointapts.com/",
  "property_domain": "https://www.highpointapts.com/",
  "property_address": "420 Kent Dr",
  "property_full_address": "420 Kent Dr, Bellefontaine, OH 43311",
  "property_address_1": "420 Kent Dr",
  "property_address_2": null,
  "property_address_city": "Bellefontaine",
  "property_address_state": "OH",
  "property_address_zip_full": "43311-9047",
  "property_address_zip": "43311",
  "property_address_country": "US",
  "property_address_county": "Logan County",
  "property_neighborhood_address": "Ohio South Area",
  "property_address_latitude": "40.3356495",
  "property_address_longitude": "-83.7559753",
  "property_email": "hpa@dietzpropertygroup.com",
  "property_phone": "(937) 592-0665",
  "property_call_tracking_phone": "937-592-0665",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Highpoint Apartments in Bellefontaine, OH! Choose from spacious one, two, and three-bedroom floor plans tailored for comfort. Enjoy amenities like a pet-friendly fenced dog park, 24-hour emergency maintenance, and modern upgrades, all in a serene wooded setting. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to Highpoint Apartments: Your Ideal Home Awaits in Bellefontaine, OH!**\n\nDiscover the perfect blend of comfort, convenience, and community at Highpoint Apartments. Our thoughtfully designed floor plans feature one, two, and three-bedroom options, ensuring you find the perfect fit for your lifestyle. Explore all our layouts and envision your new home today!\n\nOur pet-friendly community boasts a range of exceptional amenities tailored to elevate your living experience. Enjoy peace of mind with a fenced-in dog park for your furry friends, and take advantage of our professional on-site management and 24-hour emergency maintenance services. \n\nExperience the ease of modern living with features like keyless entry, central heating and air conditioning, as well as smart card technology for convenient access to amenities. Our upgraded model homes include Tier 1 and Tier 2 options, giving you the flexibility to choose upgrades that suit your taste. \n\nLocated in an ideal area of Bellefontaine, Highpoint Apartments offers stunning views, whether it’s the peaceful wooded backdrop or a refreshing pool view right from your home. Plus, with flexible rent payment options available, we strive to accommodate your financial needs.\n\nWhy wait? Discover how Highpoint Apartments can be the perfect backdrop for your story. Browse our availability online or schedule a tour to experience the community firsthand. Your new home is just a call away—come find out why so many are choosing to make Highpoint Apartments their next home sweet home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019dcff2-66b7-7766-b1c8-b30319270a73.webp",
  "property_featured_image_media": {
    "alt_text": "Property entrance with stone facade, blue door, and manicured landscaping.",
    "public_id": "019dcff2-66b7-7766-b1c8-b30319270a73",
    "storage_key": "property/6767906449167358/019dcff2-66b7-7766-b1c8-b30319270a73.webp",
    "width": 1192,
    "height": 794
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": "2006",
  "property_year_renovated": null,
  "property_walk_score": "35",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.22222222222221",
  "property_admin_fee": "150",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Up to two pets allowed.",
  "property_pet_policy_description": "Pet Friendly Community. Up to two pets allowed. $200 one‑time pet fee for 1st pet, additional $100 for 2nd (non‑refundable) plus $30 per month pet rent (per pet).",
  "property_petpolicy_info": "Pet Policy\nPet Policy Type: Cat, Dog, Others\nOther Pets Allowed: Please call the Leasing Office for details.\nMax Number of Pets: 2\nOne-time pet fee: $300\nPet monthly rent min/max: $30 - $50\nPet policy: Pet Friendly Community. Up to two pets allowed. $200 one-time pet fee for 1st pet, additional $100 for 2nd (non-refundable) plus $30 per month pet rent (per pet). ",
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://highpointapartments.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b3-e455-72db-88bc-ae78b942e642.webp",
  "property_primary_logo_media": {
    "alt_text": "Highpoint Apartments logo",
    "public_id": "019d63b3-e455-72db-88bc-ae78b942e642",
    "storage_key": "property/6767906449167358/019d63b3-e455-72db-88bc-ae78b942e642.webp",
    "width": 700,
    "height": 254
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-79f0-75a9-8b46-0c21f67a322f.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d63b4-79f0-75a9-8b46-0c21f67a322f",
    "storage_key": "property/6767906449167358/019d63b4-79f0-75a9-8b46-0c21f67a322f.webp",
    "width": 700,
    "height": 254
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-55a3-774f-a6cd-d516ba5d51ff.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63b4-55a3-774f-a6cd-d516ba5d51ff",
    "storage_key": "property/6767906449167358/019d63b4-55a3-774f-a6cd-d516ba5d51ff.webp",
    "width": 700,
    "height": 254
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "759 - 1275",
  "property_sqft_min": "759",
  "property_sqft_max": "1275",
  "property_price_range": "1080 - 1610",
  "property_price_min": "1080",
  "property_price_max": "1610",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/HighpointApartmentsDPG",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7a-peIYvP4gR5mnJhn4bDZs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/highpoint-apartments-bellefontaine",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Highpoint Apartments",
  "property_home_romance_title": "Embrace a New Chapter in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "At Highpoint Apartments in Bellefontaine, OH, your ideal home awaits! Choose from spacious one, two, or three-bedroom options designed for comfort and style. Enjoy pet-friendly amenities like our fenced-in dog park, 24-hour emergency maintenance, and scenic wooded views. Experience flexible rent payments and on-site management that truly cares.",
  "property_home_floorplans_blurb": "Welcome to Highpoint Apartments in Bellefontaine, OH, where modern living meets cozy comfort. Choose from spacious one, two, or three-bedroom layouts designed with your lifestyle in mind. Dive into the ideal space for you and your loved ones—your future home awaits right here at Highpoint!",
  "property_home_gallery_blurb": "At Highpoint Apartments in Bellefontaine, OH, your ideal home awaits. Choose from spacious one, two, or three-bedroom floor plans, all designed with comfort in mind. Enjoy our pet-friendly community featuring a fenced-in dog park, smart home amenities, and 24-hour emergency maintenance. Picture yourself living here, where convenience meets tranquility!",
  "property_home_neighborhood_blurb": "Welcome to Highpoint Apartments in Bellefontaine, OH, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans nestled near vibrant parks, schools, and cultural hotspots like the Holland Theatre and Zane Shawnee Caverns. Here, your ideal lifestyle awaits just moments from home. ",
  "property_home_reviews_blurb": "At Highpoint Apartments in Bellefontaine, our residents rave about the exceptional service they receive. One satisfied resident shares, “The management here is amazing... they just lured me in with kindness.” Join a community where support and comfort define your living experience. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Highpoint Apartments in Bellefontaine, immerse yourself in a vibrant community rich with attractions. From scenic parks and educational institutions to the captivating history of the Logan County History Center, there's always something to engage your senses. Join us and enjoy the perfect blend of convenience and excitement!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Highpoint Apartments in Bellefontaine, OH, embrace a lifestyle of comfort and convenience. Enjoy spacious one, two, and three-bedroom floor plans, a pet-friendly fenced dog park, and modern amenities like smart technology and 24-hour emergency maintenance. Experience exceptional living—your serene oasis awaits amidst wooded views and professional management.",
  "property_applynow_blurb": "At Highpoint Apartments in Bellefontaine, OH, find your perfect living space among our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy exceptional amenities like a fenced dog park, 24-hour emergency maintenance, and upgrades that enhance your lifestyle. Embrace comfort and convenience—secure your new home online today!",
  "property_contactus_blurb": "At Highpoint Apartments in Bellefontaine, OH, find the perfect fit with our diverse floor plans, including one, two, and three-bedroom options. Each home is designed for comfort and style, catering to your unique lifestyle. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Highpoint Apartments in Bellefontaine, OH, we cater to your lifestyle with spacious one, two, and three-bedroom floor plans designed for comfort and convenience. For any questions about our vibrant community and all it has to offer, browse our FAQs page for quick answers tailored just for you.",
  "property_floorplans_blurb": "At Highpoint Apartments in Bellefontaine, OH, we offer a variety of thoughtfully designed floor plans to fit your lifestyle. Whether you seek the cozy comfort of a one-bedroom, the spaciousness of a two-bedroom, or the roominess of a three-bedroom, your ideal home awaits. Browse our available apartments today!",
  "property_gallery_blurb": "At Highpoint Apartments in Bellefontaine, OH, each of our thoughtfully designed one, two, and three-bedroom floor plans offers an inviting retreat. Enjoy delightful amenities like a fenced-in dog park, upgraded interiors, and serene wooded views. Picture yourself living here and experience the perfect blend of comfort and convenience!",
  "property_interactivemap_blurb": "At Highpoint Apartments in Bellefontaine, OH, your perfect home awaits! Choose from one, two, or three-bedroom floor plans and enjoy unique amenities like a fenced-in dog park, welcoming professional management, and 24/7 emergency maintenance. Dive into your ideal lifestyle using our interactive community map for easy apartment selection!",
  "property_pets_blurb": "At Highpoint Apartments in Bellefontaine, OH, your furry friends are more than welcome! Our pet-friendly community allows two pets, ensuring your home is as lively as your lifestyle. With spacious living and scenic surroundings, indulge in the perfect blend of comfort and community just for you and your pets.",
  "property_referafriend_blurb": "At Highpoint Apartments in Bellefontaine, OH, every floor plan is designed for comfort and style, from inviting one-bedrooms to spacious three-bedrooms. Share the experience—great friends make great neighbors! Refer a friend today and embrace an exceptional living community where connections flourish.",
  "property_residentaccess_blurb": "Welcome to Highpoint Apartments in Bellefontaine, OH, where comfort meets convenience. With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Don’t forget to access your resident portal today—it’s your gateway to effortless rent payments, maintenance requests, and more!",
  "property_reviews_blurb": "At Highpoint Apartments in Bellefontaine, OH, residents rave about our exceptional management team. As one satisfied tenant exclaims, “Olivia Barhost expedited my rental application within days!” Enjoy picturesque views, clean amenities, and a welcoming community atmosphere. Curious about life at Highpoint? See what our residents have to say!",
  "property_created_at": "1775494179335",
  "property_scheduletour_blurb": "At Highpoint Apartments in Bellefontaine, OH, your perfect home awaits—choose from our thoughtfully designed one, two, or three-bedroom floor plans. Experience a vibrant community where comfort meets convenience. Curious? Schedule a tour and see what our residents love about life at Highpoint! ",
  "property_thankyou_blurb": "Thank you for reaching out to Highpoint Apartments in charming Bellefontaine, OH! We offer a variety of spacious floor plans, including one, two, and three-bedroom options, designed to meet your unique lifestyle needs. Stay tuned for a member of our team to connect with you soon! ",
  "property_virtualtours_blurb": "At Highpoint Apartments in Bellefontaine, OH, your dream home awaits with inviting one, two, and three-bedroom floor plans tailored to your lifestyle. Experience modern living in style! Ready to see for yourself? Take a virtual tour of our beautiful community and discover your perfect apartment today!",
  "property_copyright": "2026 All Rights Reserved. Highpoint Apartments",
  "property_seo_title_home": "Highpoint Apartments |  Apartments in Bellefontaine, OH",
  "property_seo_description_home": "Discover modern living at Highpoint Apartments in Bellefontaine, OH. Enjoy spacious, pet-friendly homes. Find your ideal space today!",
  "property_seo_title_floorplans": "Floor Plans | Bellefontaine, OH Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Highpoint Apartments in Bellefontaine, OH! Browse unique one-, two-, and three-bedroom floor plans tailored for your perfect home.",
  "property_seo_title_amenities": "Amenities | Bellefontaine, OH Apartments for Rent",
  "property_seo_description_amenities": "Experience refined living at Highpoint Apartments in Bellefontaine, OH. From pet-friendly spaces to modern amenities, find your perfect haven today!",
  "property_seo_title_gallery": "Gallery | Apartments in Bellefontaine, OH",
  "property_seo_description_gallery": "Experience life at Highpoint Apartments in Bellefontaine, OH! From spacious floor plans to a pet-friendly dog park, envision your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Highpoint Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Highpoint Apartments in Bellefontaine, OH. Take a virtual tour today and find your perfect one, two, or three-bedroom home!",
  "property_seo_title_interactivemap": "Interactive Map | Highpoint Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Highpoint Apartments in Bellefontaine! Enjoy pet-friendly living with modern amenities, scenic views, and flexible rent options.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bellefontaine, OH",
  "property_seo_description_neighborhood": "Uncover the charm of Bellefontaine, OH! Highpoint Apartments connects you to local favorites and hidden gems just steps from your door. Let adventure begin!",
  "property_seo_title_contact": "Contact Us | Highpoint Apartments",
  "property_seo_description_contact": "Find your perfect home at Highpoint Apartments in Bellefontaine, OH. With one to three-bedroom layouts, our leasing team is ready to answer your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Bellefontaine, OH",
  "property_seo_description_faqs": "Explore Highpoint Apartments in Bellefontaine, OH. Learn about our amenities, floor plans, and pet-friendly community at your convenience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bellefontaine, OH",
  "property_seo_description_reviews": "Discover life at Highpoint Apartments in Bellefontaine, OH! Read resident reviews about our spacious layouts and pet-friendly amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Bellefontaine, OH",
  "property_seo_description_applynow": "Find your perfect home at Highpoint Apartments in Bellefontaine! Enjoy spacious floor plans, pet-friendly amenities, and a serene setting. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Highpoint Apartments",
  "property_seo_description_residentaccess": "Log in to Highpoint Apartments' portal to pay rent, schedule maintenance, and manage your Bellefontaine home—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Highpoint Apartments",
  "property_seo_description_referafriend": "Refer a friend to Highpoint Apartments in Bellefontaine, OH, where great friendships flourish and neighbors become family! Join our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Highpoint Apartments",
  "property_seo_description_scheduletour": "Discover vibrant living at Highpoint Apartments in Bellefontaine, OH. Schedule your tour today and envision your new community!",
  "property_seo_title_privacy": "Privacy Policy | Highpoint Apartments",
  "property_seo_description_privacy": "At Highpoint Apartments in Bellefontaine, OH, we prioritize your privacy. Learn how we safeguard your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Highpoint Apartments",
  "property_seo_description_accessibility": "At Highpoint Apartments in Bellefontaine, OH, we prioritize digital inclusion. Join us in creating an accessible community where everyone can thrive!",
  "property_seo_title_sitemap": "Sitemap | Highpoint Apartments",
  "property_seo_description_sitemap": "Navigate your way through Highpoint Apartments in Bellefontaine, OH! Find your perfect home layout and amenities with our easy-to-use sitemap today.",
  "property_seo_title_thankyou": "Thank You | Highpoint Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Highpoint Apartments in Bellefontaine, OH, is excited to connect. Your journey to exceptional living starts here—stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bellefontaine, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792124723723",
  "amenities": [
    {
      "id": "ec_40f56f5fef320301ef2699aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000617",
      "title": "Professional Management",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a50a19e99eff04b62eb2a43f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000619",
      "title": "Ideal Location",
      "amount": "0.0000",
      "description": "Nearby Shopping and Entertainment",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bee6ee8830efdfa3dad156fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000697",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c33d420ecaf31936d42b5d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000698",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fitness center with some weights and  exercise equipment",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab5867acfa707969c6874d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000701",
      "title": "24 Hour Emergency Maintenance",
      "amount": "0.0000",
      "description": "24 Hour Emergency Maintenance",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f09f2c9b8abc35d692bbf07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000702",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Flexible Rent Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c79dd307bec4a67ff7a2768",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000715",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Pool",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_263b1ea87518f4c45e43be7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000716",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d84e50e3c85f6d5c2fc13d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000681",
      "title": "Vaulted Ceilings*",
      "amount": "0.0000",
      "description": " Vaulted ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_052781e3fb0e843547640320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000684",
      "title": "Walk-in Closets",
      "amount": "0.0000",
      "description": "Spacious Walk-In Closets*",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86c410099e92a2811eb635a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "P000000693",
      "title": "Central Heat & Air",
      "amount": "0.0000",
      "description": "Central Heat & Air Conditionin",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f9d58c6b1bd6dcebe7402d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "realpage",
      "external_id": "S100000159",
      "title": "Refrigerator",
      "amount": "15.0000",
      "description": "Side-by-side refrigerator with no ice dispenser",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f6cd2205-3c47-4be1-879a-97e35c3bf0e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-6ed2-7327-92cb-7f645821fd37.webp",
      "image_media": {
        "alt_text": "Highpoint Apartments monument sign with landscaping.",
        "public_id": "01a178d4-6ed2-7327-92cb-7f645821fd37",
        "storage_key": "property/6767906449167358/01a178d4-6ed2-7327-92cb-7f645821fd37.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Highpoint Apartments, a beautiful community with a prominent monument sign surrounded by lush landscaping and mature trees.",
      "link": "",
      "alt_text": "Highpoint Apartments monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_431ffb92-e55e-439b-9861-64240ec4f555",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019dcff2-66b7-7766-b1c8-b30319270a73.webp",
      "image_media": {
        "alt_text": "Property entrance with stone facade, blue door, and manicured landscaping at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019dcff2-66b7-7766-b1c8-b30319270a73",
        "storage_key": "property/6767906449167358/019dcff2-66b7-7766-b1c8-b30319270a73.webp",
        "width": 1192,
        "height": 794
      },
      "title": "Community",
      "description": "Welcome to the property entrance, featuring a striking stone facade, a vibrant blue door, and beautifully maintained landscaping with colorful flowers and lush greenery.",
      "link": "",
      "alt_text": "Property entrance with stone facade, blue door, and manicured landscaping at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d875809b-8644-4e3f-ad83-04f51ce639fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-6bf9-730e-b99a-1341a167bd69.webp",
      "image_media": {
        "alt_text": "Clubhouse living room with fireplace and seating",
        "public_id": "01a178d4-6bf9-730e-b99a-1341a167bd69",
        "storage_key": "property/6767906449167358/01a178d4-6bf9-730e-b99a-1341a167bd69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting clubhouse living room, featuring a cozy fireplace and comfortable seating areas.",
      "link": "",
      "alt_text": "Clubhouse living room with fireplace and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8bd38b4-8e97-48ba-9e6a-7ddc5c1e570f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-e035-7238-9c33-b73609662834.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, seating, and kitchenette bar.",
        "public_id": "01a178d3-e035-7238-9c33-b73609662834",
        "storage_key": "property/6767906449167358/01a178d3-e035-7238-9c33-b73609662834.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a cozy fireplace, comfortable seating, and a convenient kitchenette bar.",
      "link": "",
      "alt_text": "Community lounge area with fireplace, seating, and kitchenette bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a628dbd-858c-4b3c-b7a4-b235c9f3c030",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-f92e-7275-b84e-0332b7299dc7.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, a weight machine, and a TV.",
        "public_id": "01a178d3-f92e-7275-b84e-0332b7299dc7",
        "storage_key": "property/6767906449167358/01a178d3-f92e-7275-b84e-0332b7299dc7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center featuring cardio machines, free weights, and a cable TV.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, a weight machine, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c76974f2-0042-44a7-8270-e67af1a70559",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-d683-7669-8293-46854ea6846e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmill, elliptical, and weight machine.",
        "public_id": "01a178d3-d683-7669-8293-46854ea6846e",
        "storage_key": "property/6767906449167358/01a178d3-d683-7669-8293-46854ea6846e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmill, elliptical, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3835a69-8f48-44ee-ac08-ed33e5b3662b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-fe49-744c-80d5-f1f6e3228d61.webp",
      "image_media": {
        "alt_text": "A bright and airy dining area with a vaulted ceiling and a view of the kitchen.",
        "public_id": "01a178d3-fe49-744c-80d5-f1f6e3228d61",
        "storage_key": "property/6767906449167358/01a178d3-fe49-744c-80d5-f1f6e3228d61.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this apartment's dining area, featuring a vaulted ceiling and a connected, fully-equipped kitchen for convenient meal preparation.",
      "link": "",
      "alt_text": "A bright and airy dining area with a vaulted ceiling and a view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3e8b8fe-9ee5-4db7-abf2-d5cea1662f2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-fabd-74d6-b40a-5c0882213911.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceilings and two windows.",
        "public_id": "01a178d3-fabd-74d6-b40a-5c0882213911",
        "storage_key": "property/6767906449167358/01a178d3-fabd-74d6-b40a-5c0882213911.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with vaulted ceilings and ample natural light from two large windows. This room offers a comfortable and inviting atmosphere for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with vaulted ceilings and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49ae9973-6023-4323-aa6d-716d7c2f87a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-fc65-70a8-886b-f399de06756f.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, including a stove and refrigerator, and white cabinets.",
        "public_id": "01a178d3-fc65-70a8-886b-f399de06756f",
        "storage_key": "property/6767906449167358/01a178d3-fc65-70a8-886b-f399de06756f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore the functional kitchen space featuring essential appliances and ample cabinet storage, perfect for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with white appliances, including a stove and refrigerator, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7946ca32-11e2-4693-82e7-49d1a1e1c60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-f789-701b-8b5b-0157b9379897.webp",
      "image_media": {
        "alt_text": "Interior of a vacant apartment unit, showing a hallway with doors, a glimpse of the kitchen, and a sunlit living area.",
        "public_id": "01a178d3-f789-701b-8b5b-0157b9379897",
        "storage_key": "property/6767906449167358/01a178d3-f789-701b-8b5b-0157b9379897.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment unit, featuring a spacious layout with a hallway leading to various rooms, a functional kitchen, and a bright living area illuminated by natural light.",
      "link": "",
      "alt_text": "Interior of a vacant apartment unit, showing a hallway with doors, a glimpse of the kitchen, and a sunlit living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e33f5ef-48a6-4008-9865-c2e5b117311b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-e091-7470-8c34-7e80530c1b1e.webp",
      "image_media": {
        "alt_text": "A clean and bright bathroom with a white vanity, sink, and toilet. A shower/tub combo is visible in the mirror.",
        "public_id": "01a178d3-e091-7470-8c34-7e80530c1b1e",
        "storage_key": "property/6767906449167358/01a178d3-e091-7470-8c34-7e80530c1b1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious bathroom, complete with a modern vanity, sink, and a convenient shower/tub combo.",
      "link": "",
      "alt_text": "A clean and bright bathroom with a white vanity, sink, and toilet. A shower/tub combo is visible in the mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8995b8a-cd9a-406c-90bc-ee1caf08caad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-d9e7-712f-848a-258d2f7cce5a.webp",
      "image_media": {
        "alt_text": "A white bathtub and shower unit with a silver faucet and shower head.",
        "public_id": "01a178d3-d9e7-712f-848a-258d2f7cce5a",
        "storage_key": "property/6767906449167358/01a178d3-d9e7-712f-848a-258d2f7cce5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this apartment's clean and modern bathroom, featuring a pristine white bathtub and shower combination.",
      "link": "",
      "alt_text": "A white bathtub and shower unit with a silver faucet and shower head.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec8a1913-d545-4ff6-bcf9-41b7a9576108",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-4884-755e-9249-a586a749756c.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls and carpet. Open closet doors reveal storage space.",
        "public_id": "01a178d4-4884-755e-9249-a586a749756c",
        "storage_key": "property/6767906449167358/01a178d4-4884-755e-9249-a586a749756c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience spacious living in this inviting bedroom, featuring plush carpeting and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls and carpet. Open closet doors reveal storage space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9580d75a-4789-4a41-b8dc-6259252ba10c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-61e7-726e-a22c-393f773a52c8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls and carpet flooring.",
        "public_id": "01a178d4-61e7-726e-a22c-393f773a52c8",
        "storage_key": "property/6767906449167358/01a178d4-61e7-726e-a22c-393f773a52c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty bedroom features neutral walls and plush carpet flooring, providing a blank canvas for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls and carpet flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc2d333b-e902-415c-a5b8-68b95b827c5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d3-e60b-7357-bff9-0a822f21c6ac.webp",
      "image_media": {
        "alt_text": "Laundry closet with washer and dryer",
        "public_id": "01a178d3-e60b-7357-bff9-0a822f21c6ac",
        "storage_key": "property/6767906449167358/01a178d3-e60b-7357-bff9-0a822f21c6ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit laundry closet featuring a full-size washer and dryer with overhead shelving for storage.",
      "link": "",
      "alt_text": "Laundry closet with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee857834-054f-4769-8832-40181e8e26e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-0ec1-7053-9567-ce9d8e4d23c4.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen and dining area, featuring white appliances and cabinetry at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-0ec1-7053-9567-ce9d8e4d23c4",
        "storage_key": "property/6767906449167358/019d63b7-0ec1-7053-9567-ce9d8e4d23c4.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area with white appliances, ample cabinet space, and neutral carpeting, perfect for comfortable living.",
      "link": "",
      "alt_text": "Interior view of an apartment kitchen and dining area, featuring white appliances and cabinetry at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5a3fe9d-c537-41fc-8395-03b5eaeb7f13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-074f-77bd-b86c-2d07d291f432.webp",
      "image_media": {
        "alt_text": "Kitchenette and living area with two windows at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-074f-77bd-b86c-2d07d291f432",
        "storage_key": "property/6767906449167358/019d63b7-074f-77bd-b86c-2d07d291f432.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Open layout featuring a kitchenette and a spacious living area with abundant natural light from two large windows.",
      "link": "",
      "alt_text": "Kitchenette and living area with two windows at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57db5b09-83e2-4e3c-9048-17fc079b8772",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-0628-74db-bd1d-03bf7a87da60.webp",
      "image_media": {
        "alt_text": "Compact kitchen with white appliances, light wood cabinetry, and a double sink at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-0628-74db-bd1d-03bf7a87da60",
        "storage_key": "property/6767906449167358/019d63b7-0628-74db-bd1d-03bf7a87da60.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "This apartment kitchen features ample storage with light wood cabinets, a full-size refrigerator, stove, and a double-basin sink.",
      "link": "",
      "alt_text": "Compact kitchen with white appliances, light wood cabinetry, and a double sink at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4dfdd0b9-e6a6-4083-b55b-479b79230f67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-224b-73d6-835e-360bb809ec1e.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-224b-73d6-835e-360bb809ec1e",
        "storage_key": "property/6767906449167358/019d63b7-224b-73d6-835e-360bb809ec1e.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a shower/tub combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fed6902-99e1-4b71-bd77-7f974e2a0aaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-3198-729c-bd31-2be704586010.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-3198-729c-bd31-2be704586010",
        "storage_key": "property/6767906449167358/019d63b7-3198-729c-bd31-2be704586010.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access within your apartment home.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11b6d065-e1b4-43f0-b9de-694ccc664b8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-ff8e-73c1-a0b8-58dc157f51c5.webp",
      "image_media": {
        "alt_text": "Fenced dog park area with benches and agility equipment at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b6-ff8e-73c1-a0b8-58dc157f51c5",
        "storage_key": "property/6767906449167358/019d63b6-ff8e-73c1-a0b8-58dc157f51c5.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced dog park, perfect for your furry friends to play and socialize. Features include benches for relaxing and agility equipment for fun.",
      "link": "",
      "alt_text": "Fenced dog park area with benches and agility equipment at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ee9e6e8-7ad9-4ceb-89fd-6d0e38d76737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b7-03e2-7409-98e1-a748de6625be.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment and grassy lawn at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b7-03e2-7409-98e1-a748de6625be",
        "storage_key": "property/6767906449167358/019d63b7-03e2-7409-98e1-a748de6625be.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, complete with agility equipment for your furry friends to play and exercise in.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment and grassy lawn at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_773f7c90-eef0-46c5-b6f7-27ecc3e4e63c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-46a2-73ba-bda5-a9ca432ee310.webp",
      "image_media": {
        "alt_text": "Highpoint Apartments dog park with agility equipment and seating.",
        "public_id": "01a178d4-46a2-73ba-bda5-a9ca432ee310",
        "storage_key": "property/6767906449167358/01a178d4-46a2-73ba-bda5-a9ca432ee310.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park at Highpoint Apartments, complete with agility equipment and benches for you and your furry friend.",
      "link": "",
      "alt_text": "Highpoint Apartments dog park with agility equipment and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d48fd466-d25c-48f9-9c76-b932040f02c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-e6f3-72cb-8483-e90f06ee721d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b6-e6f3-72cb-8483-e90f06ee721d",
        "storage_key": "property/6767906449167358/019d63b6-e6f3-72cb-8483-e90f06ee721d.webp",
        "width": 1100,
        "height": 733
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Enjoy a refreshing dip or soak up the sun in this beautiful community amenity.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a398e430-2110-4a0e-8e77-f487f6dd5f9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-462f-775b-9dda-55455dde4903.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a grilling station.",
        "public_id": "01a178d4-462f-775b-9dda-55455dde4903",
        "storage_key": "property/6767906449167358/01a178d4-462f-775b-9dda-55455dde4903.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient grilling stations for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a grilling station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a71eaa0b-ebc0-4eb4-b33c-85b3d3b42846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-4433-70b8-abd6-7dcec46f4926.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a178d4-4433-70b8-abd6-7dcec46f4926",
        "storage_key": "property/6767906449167358/01a178d4-4433-70b8-abd6-7dcec46f4926.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed08fd64-36f9-49ae-9bf4-863de1639753",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d4-4759-72b4-b452-a554369a71bb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with a vibrant red tree in front during autumn.",
        "public_id": "01a178d4-4759-72b4-b452-a554369a71bb",
        "storage_key": "property/6767906449167358/01a178d4-4759-72b4-b452-a554369a71bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community. Enjoy the charming exterior and beautiful autumn foliage, creating a picturesque setting.",
      "link": "",
      "alt_text": "Exterior view of apartment building with a vibrant red tree in front during autumn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ffebb229-adac-4098-8837-1c1802537173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d6-4f40-7656-9175-e3c0874bd20e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool, clubhouse, and surrounding grounds.",
        "public_id": "01a178d6-4f40-7656-9175-e3c0874bd20e",
        "storage_key": "property/6767906449167358/01a178d6-4f40-7656-9175-e3c0874bd20e.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover resort-style living at our community, featuring a sparkling swimming pool and a welcoming clubhouse. Enjoy the beautifully landscaped grounds and convenient amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with swimming pool, clubhouse, and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_832f77a4-e1ea-440b-a81c-fe9fe7e64eb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-c677-7345-b230-1e9563ffec6c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone and vinyl siding under a blue sky with white clouds at Highpoint Apartments in Bellefontaine, OH.",
        "public_id": "019d63b6-c677-7345-b230-1e9563ffec6c",
        "storage_key": "property/6767906449167358/019d63b6-c677-7345-b230-1e9563ffec6c.webp",
        "width": 1100,
        "height": 732
      },
      "title": "Community",
      "description": "Charming apartment buildings feature a mix of stone and vinyl siding, with blue shutters and manicured landscaping, set against a bright blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with stone and vinyl siding under a blue sky with white clouds at Highpoint Apartments in Bellefontaine, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fbdffcd0-b3e2-4f3e-81eb-89841594c2eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d6-4f3c-773e-9027-a212629b7f7a.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and apartment buildings.",
        "public_id": "01a178d6-4f3c-773e-9027-a212629b7f7a",
        "storage_key": "property/6767906449167358/01a178d6-4f3c-773e-9027-a212629b7f7a.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim at our sparkling outdoor pool, surrounded by beautiful landscaping and the community's apartment buildings. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5974174f-58f8-4e2a-9415-5cc95f23add7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d6-4d36-75e9-86f9-5597303e4df1.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and parking lots.",
        "public_id": "01a178d6-4d36-75e9-86f9-5597303e4df1",
        "storage_key": "property/6767906449167358/01a178d6-4d36-75e9-86f9-5597303e4df1.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcases apartment buildings, a swimming pool, and ample parking. The community is surrounded by lush greenery and trees.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and parking lots.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f0063da-f5dc-4bad-8ab6-f6155b510e3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/01a178d6-4fb7-7004-a55a-4264ef4e6174.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool at a multifamily property.",
        "public_id": "01a178d6-4fb7-7004-a55a-4264ef4e6174",
        "storage_key": "property/6767906449167358/01a178d6-4fb7-7004-a55a-4264ef4e6174.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, the perfect spot for relaxation and fun. Located at our beautiful multifamily property.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3b76781d-a322-4605-9acc-d05c60dcaf0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Six Hundred Downtown",
      "poi_type": "Restaurants",
      "poi_address": "108 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Popular pizzeria serving Detroit-style and signature pies, along with cocktails and beer menus.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizzas, calzones, and garlic knots. They highlight the great seating options, both inside and out, and the fun, attentive staff. They also like the beautiful atmosphere, especially the outdoor seating with the sound of the water fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-d561-7280-b2e2-d8bd13137853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-d561-7280-b2e2-d8bd13137853",
        "storage_key": "property/6767906449167358/019d7918-d561-7280-b2e2-d8bd13137853.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.600downtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=186975073660609850&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "six-hundred-downtown",
      "poi_latitude": "40.360867",
      "poi_longitude": "-83.7601031",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-599-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
      "poi_map_icon_media": {
        "alt_text": "Knife and fork icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-6323b26bc06d",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wl9dWEvP4gROqVkv9ZEmAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a57fa52a-cf44-405f-8d27-3a48f2cd4d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Brewfontaine",
      "poi_type": "Restaurants",
      "poi_address": "211 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Compact, modern bar offering rotating taps of craft beers & wine, plus sandwiches & salads.",
      "poi_long_description": "Diners say this restaurant offers a great selection of beers, tasty food like the avocado melt, and delicious bloody marys. They also highlight the friendly and attentive staff, and the fun and lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-4735-720a-8b9d-b8770c98cdeb.webp",
      "poi_featured_image_media": {
        "alt_text": "Brewfontaine restaurant exterior at night with neon sign and people inside.",
        "public_id": "019d63b4-4735-720a-8b9d-b8770c98cdeb",
        "storage_key": "property/6767906449167358/019d63b4-4735-720a-8b9d-b8770c98cdeb.webp",
        "width": 1680,
        "height": 1050
      },
      "poi_business_url": "http://www.brewfontaine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050927043765432620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brewfontaine",
      "poi_latitude": "40.3593541",
      "poi_longitude": "-83.7597347",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-404-9128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
      "poi_map_icon_media": {
        "alt_text": "Knife and fork icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-6323b26bc06d",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_OCLGIvP4gRLHHJOUx-Pac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6547edd5-ecbf-4334-8c42-f48748a0a66a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "The Morning Riot",
      "poi_type": "Restaurants",
      "poi_address": "130 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this brunch restaurant serves delicious breakfast burritos, bagels, and sandwiches. They highlight the unique and fun atmosphere, and the reasonable prices. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-d37b-7049-bc40-e7b8d44c73f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-d37b-7049-bc40-e7b8d44c73f8",
        "storage_key": "property/6767906449167358/019d7918-d37b-7049-bc40-e7b8d44c73f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://morningriot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1066541899641350923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-morning-riot",
      "poi_latitude": "40.3602662",
      "poi_longitude": "-83.76037269999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
      "poi_map_icon_media": {
        "alt_text": "Knife and fork icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-6323b26bc06d",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wPA97MvP4gRC2sx-jQezQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_156478ec-e249-4053-a585-b6ca873b9b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Don's Downtown Diner",
      "poi_type": "Restaurants",
      "poi_address": "208 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Hamburgers and other American eats in a casual environment with friendly staff.",
      "poi_long_description": "People say this diner serves great burgers, fried pickles, and milkshakes. They highlight the reasonable prices, big portions, and fresh ingredients. They also like the friendly and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-d562-748c-b428-0921cf90728d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-d562-748c-b428-0921cf90728d",
        "storage_key": "property/6767906449167358/019d7918-d562-748c-b428-0921cf90728d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/Donsdowntowndiner/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9607830579598261736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dons-downtown-diner",
      "poi_latitude": "40.359419",
      "poi_longitude": "-83.7601304",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-599-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
      "poi_map_icon_media": {
        "alt_text": "Knife and fork icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-6323b26bc06d",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7yBLmIvP4gR6P0W9wHfVYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_9663b779-8a9d-486e-b169-0cbb3baca1e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "The Flying Pepper Cantina",
      "poi_type": "Restaurants",
      "poi_address": "137 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Casual, family-owned eatery for grilled Mexican dishes, plus margaritas and other cocktails.",
      "poi_long_description": "People say this Mexican restaurant serves delicious food, including street corn, tacos, and enchiladas. They highlight the fresh ingredients, flavorful dishes, and reasonable prices. They also like the attentive and upbeat staff, and the quaint atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-258a-730c-9c4d-2732fbbff0bf.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a restaurant with a vibrant mural and unique lighting.",
        "public_id": "019d63b4-258a-730c-9c4d-2732fbbff0bf",
        "storage_key": "property/6767906449167358/019d63b4-258a-730c-9c4d-2732fbbff0bf.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.flyingpeppercantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2895323579815603816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-flying-pepper-cantina",
      "poi_latitude": "40.3610649",
      "poi_longitude": "-83.7612304",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-210-5042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
      "poi_map_icon_media": {
        "alt_text": "Knife and fork icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-6323b26bc06d",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-6323b26bc06d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaaR7GEvP4gRaK64rHRBLig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_21384982-4c39-4646-ad87-bb9a165f7be4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2168 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a great selection of flowers and garden plants. They also highlight the organized and clean layout, and the helpful and friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-0e31-75a9-a351-6a925ef556b4.webp",
      "poi_featured_image_media": {
        "alt_text": "The Lowe's logo on a blue brick building facade",
        "public_id": "019d63b4-0e31-75a9-a351-6a925ef556b4",
        "storage_key": "property/6767906449167358/019d63b4-0e31-75a9-a351-6a925ef556b4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Bellefontaine/0009?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-9-_-na-_-0-_-0&y_source=1_MTE4NDQ2MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12148879597111174648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.330126",
      "poi_longitude": "-83.76364199999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-599-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-5dee844e9824.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-5dee844e9824",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-5dee844e9824.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQxsZOogvP4gR-GXNRKB9mag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9ac65cae-c00c-40c2-8cba-71bbe351928d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2129 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-2279-7010-b46f-14db01a3afac.webp",
      "poi_featured_image_media": {
        "alt_text": "Kroger grocery store exterior with signage and pharmacy entrance.",
        "public_id": "019d63b4-2279-7010-b46f-14db01a3afac",
        "storage_key": "property/6767906449167358/019d63b4-2279-7010-b46f-14db01a3afac.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/bellefontaine/bellefontaine/016/00832?cid=loc_01600832_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3342860515876212390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.3309428",
      "poi_longitude": "-83.760404",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-599-1208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b8-1ad8-76f1-b3d9-5daa526a1523",
        "storage_key": "property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUnFD4gvP4gRpg57ju05ZC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7e424fff-2ac0-414c-9401-c33fc8fbb77a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Wengers Produce",
      "poi_type": "Shopping & Retail",
      "poi_address": "3836 County Rd 29, West Liberty, OH 43357, USA",
      "poi_short_description": "Retail outfit for locally grown fruits and vegetables, plus baked goods, cheeses and meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-d490-74fd-a5fa-f56e9f8ed2a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-d490-74fd-a5fa-f56e9f8ed2a6",
        "storage_key": "property/6767906449167358/019d7918-d490-74fd-a5fa-f56e9f8ed2a6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/people/Wengers-Produce/100057126413919/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3310470150169562937&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wengers-produce",
      "poi_latitude": "40.3037242",
      "poi_longitude": "-83.70159509999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 937-592-5726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b8-1ad8-76f1-b3d9-5daa526a1523",
        "storage_key": "property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQ7wBiEuP4gROQ9k3A8n8S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4b592d44-a7d7-4588-8167-dd1e69d64b4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2175 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-e883-7680-bec8-c4779b0eed52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-e883-7680-bec8-c4779b0eed52",
        "storage_key": "property/6767906449167358/019d7918-e883-7680-bec8-c4779b0eed52.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/oh/bellefontaine/2175-us-highway-68-s/f512",
      "poi_directions_map_url": "https://maps.google.com/?cid=13433590194047931504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.33007",
      "poi_longitude": "-83.76062",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b8-1ad8-76f1-b3d9-5daa526a1523",
        "storage_key": "property/6767906449167358/019d63b8-1ad8-76f1-b3d9-5daa526a1523.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYTXkYkvP4gRcNRldhuzbbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_35d0b4ee-4db8-4ed4-bfd9-84a10d2b4860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Lutheran Community Services",
      "poi_type": "Shopping & Retail",
      "poi_address": "820 W Sandusky Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Low-cost secondhand shop with clothes and household items for sale to support local charities and services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-352f-7249-982f-5448b4f65d21.webp",
      "poi_featured_image_media": {
        "alt_text": "Two giraffes, an adult and a baby, nuzzling each other.",
        "public_id": "019d63b4-352f-7249-982f-5448b4f65d21",
        "storage_key": "property/6767906449167358/019d63b4-352f-7249-982f-5448b4f65d21.webp",
        "width": 937,
        "height": 961
      },
      "poi_business_url": "https://becomebettertogether.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12237504165271255903&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lutheran-community-services",
      "poi_latitude": "40.363829",
      "poi_longitude": "-83.77262499999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-592-9914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-5dee844e9824.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63b8-1a06-73d5-bd7a-5dee844e9824",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-5dee844e9824.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcx7dnYolP4gRXztbhDNZ1Kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_c430874f-24bf-436e-8599-e2b9811f7e30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Logan County Libraries",
      "poi_type": "Education",
      "poi_address": "220 N Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Public library with a children's section offering a range of board books and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-f14d-723f-9c39-07a5d91bd683.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-f14d-723f-9c39-07a5d91bd683",
        "storage_key": "property/6767906449167358/019d7918-f14d-723f-9c39-07a5d91bd683.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://logancountylibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16932861840026475643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "logan-county-libraries",
      "poi_latitude": "40.363738",
      "poi_longitude": "-83.7590603",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-599-4189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a11-701e-9ae3-9fff80be5eda.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b8-1a11-701e-9ae3-9fff80be5eda",
        "storage_key": "property/6767906449167358/019d63b8-1a11-701e-9ae3-9fff80be5eda.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ91ch92AvP4gRe5yLHSGc_eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ae62447e-9271-4b12-ab99-e501ddcbd242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Piatt Castle Mac-A-Cheek",
      "poi_type": "Entertainment",
      "poi_address": "10051 Township Rd 47, West Liberty, OH 43357, USA",
      "poi_short_description": "Estate with 2 castle-style historic homes, featuring artifacts & exhibits on Ohio history.",
      "poi_long_description": "Estate with 2 castle-style historic homes, featuring artifacts & exhibits on Ohio history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-ef20-71a3-9a7e-30c805d2f70f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-ef20-71a3-9a7e-30c805d2f70f",
        "storage_key": "property/6767906449167358/019d7918-ef20-71a3-9a7e-30c805d2f70f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://piattcastle.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6393053394559602793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piatt-castle-mac-a-cheek",
      "poi_latitude": "40.25105430000001",
      "poi_longitude": "-83.72679049999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 937-465-2821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-674bc839bd20.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M",
        "public_id": "019d63b8-1a06-73d5-bd7a-674bc839bd20",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-674bc839bd20.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dd79-8wP4gRaZDUxDCwuFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7af9c699-6f16-44d0-b54e-eb899e2dbbef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Logan County History Center",
      "poi_type": "Entertainment",
      "poi_address": "521 E Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Museum of local history that consists of a mansion, exhibits and research room.",
      "poi_long_description": "People say this history museum offers a wide variety of artifacts pertaining to transportation, agriculture, electronics, and the US military. They highlight the fascinating historical pieces and the well-organized exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-7930-70eb-8c63-d5c8417fc100.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a multifamily property featuring a large yellow house with white trim and columns, a parking lot, and a white fence.",
        "public_id": "019d63b4-7930-70eb-8c63-d5c8417fc100",
        "storage_key": "property/6767906449167358/019d63b4-7930-70eb-8c63-d5c8417fc100.webp",
        "width": 1275,
        "height": 1650
      },
      "poi_business_url": "http://loganhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168627646289126221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "logan-county-history-center",
      "poi_latitude": "40.361351",
      "poi_longitude": "-83.7507705",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-593-7557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a06-73d5-bd7a-674bc839bd20.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M",
        "public_id": "019d63b8-1a06-73d5-bd7a-674bc839bd20",
        "storage_key": "property/6767906449167358/019d63b8-1a06-73d5-bd7a-674bc839bd20.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQe45vmgvP4gRTaMnu1qDGB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_7170e58d-2aa1-42a6-a990-8a4411653bc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "AccuSport Stadium",
      "poi_type": "Entertainment",
      "poi_address": "555 E Lake Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-f1e4-7467-b19f-0d622c1e688d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-f1e4-7467-b19f-0d622c1e688d",
        "storage_key": "property/6767906449167358/019d7918-f1e4-7467-b19f-0d622c1e688d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=1952",
      "poi_directions_map_url": "https://maps.google.com/?cid=75909093468098867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "accusport-stadium",
      "poi_latitude": "40.3490534",
      "poi_longitude": "-83.75279259999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad1-767d-bd5a-18a63e1c4578.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon representing people in conversation",
        "public_id": "019d63b8-1ad1-767d-bd5a-18a63e1c4578",
        "storage_key": "property/6767906449167358/019d63b8-1ad1-767d-bd5a-18a63e1c4578.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEUT1SF8vP4gRM1FjF-uuDQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_da976b0c-cca5-4bc7-80e1-abc904991deb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Court Avenue - Oldest Concrete Street In America",
      "poi_type": "Entertainment",
      "poi_address": "101-163 E Court Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-fdb4-73ab-8101-2b09473a2738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-fdb4-73ab-8101-2b09473a2738",
        "storage_key": "property/6767906449167358/019d7918-fdb4-73ab-8101-2b09473a2738.webp",
        "width": 1280,
        "height": 981
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6480238682727759064&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "court-avenue---oldest-concrete-street-in-america",
      "poi_latitude": "40.3604128",
      "poi_longitude": "-83.7596183",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL80TeGEvP4gR2Ly7h79u7lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_1b5c7ecb-d946-4b82-9df4-45840e427d4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Don M. And Margaret Hilliker YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Sloan Blvd, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym has a clean facility with a pool and a decent weights area. They also highlight the helpful and pleasant staff.\n\nSome reviews mention the membership fees can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b4-cb26-71aa-9f6d-3b287410f585.webp",
      "poi_featured_image_media": {
        "alt_text": "Building entrance with covered walkway and landscaping.",
        "public_id": "019d63b4-cb26-71aa-9f6d-3b287410f585",
        "storage_key": "property/6767906449167358/019d63b4-cb26-71aa-9f6d-3b287410f585.webp",
        "width": 1400,
        "height": 651
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/hilliker?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_hilliker",
      "poi_directions_map_url": "https://maps.google.com/?cid=2480290566107687829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-m-and-margaret-hilliker-ymca---ymca-of-central-ohio",
      "poi_latitude": "40.36471179999999",
      "poi_longitude": "-83.717186",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-389-4364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1wFuiAvP4gRleuZ9CDDayI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9a004285-4c5a-4402-8218-aeb476ab308e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "North Side Animal Clinic Inc",
      "poi_type": "Health and Wellness",
      "poi_address": "1770 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b5-1cef-77b3-879c-7eafcf00fe89.webp",
      "poi_featured_image_media": {
        "alt_text": "Black dog lying on the floor with a purple leash.",
        "public_id": "019d63b5-1cef-77b3-879c-7eafcf00fe89",
        "storage_key": "property/6767906449167358/019d63b5-1cef-77b3-879c-7eafcf00fe89.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.northsideanimalclinicinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13039789352799597602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-side-animal-clinic-inc",
      "poi_latitude": "40.3874555",
      "poi_longitude": "-83.75197179999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-593-6951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbkjUYcvP4gRInSKH1Sj9rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_dc2c7109-86d2-4784-8e6c-f74404ef4a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Southgate Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3142 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-085f-76da-80d8-a63b6d4fbafb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-085f-76da-80d8-a63b6d4fbafb",
        "storage_key": "property/6767906449167358/019d7919-085f-76da-80d8-a63b6d4fbafb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.southgatevet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9972309426614833579&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southgate-veterinary-clinic",
      "poi_latitude": "40.3163104",
      "poi_longitude": "-83.7608498",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-592-9816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Uoh1vgvP4gRqxGog5bCZIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_56ed0414-a4b8-41bb-9ef0-456d02eb08f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "210 W Columbus Ave Suite 1, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Chain fitness center with 24/7 access, a variety of equipment, personal training, and group workouts.",
      "poi_long_description": "People say this gym offers a variety of equipment, including free weights, machines, and cardio gear, and provides access to supplements and meals. They highlight the clean facilities, well-maintained equipment, and convenient 24/7 access. They also like the friendly, knowledgeable, and supportive staff, and the welcoming and encouraging community vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-0a47-71f9-9bd7-065c5428135d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-0a47-71f9-9bd7-065c5428135d",
        "storage_key": "property/6767906449167358/019d7919-0a47-71f9-9bd7-065c5428135d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/bellefontaine-ohio-2478/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2478",
      "poi_directions_map_url": "https://maps.google.com/?cid=18180523005994453642&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "40.361509",
      "poi_longitude": "-83.7621942",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-595-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWKgD4kvP4gRisodc1kxTvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_df11f0d1-bc34-494a-97df-735541a1a3c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Q Nail Lounge +",
      "poi_type": "Health and Wellness",
      "poi_address": "2305 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Nail salon offering services such as pedicures in a clean and welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019dbbc7-597a-75a9-8dca-d706d274553f.webp",
      "poi_featured_image_media": {
        "alt_text": "Close up of a woman's hand with festive Christmas-themed nails in front of a decorated Christmas tree.",
        "public_id": "019dbbc7-597a-75a9-8dca-d706d274553f",
        "storage_key": "property/6767906449167358/019dbbc7-597a-75a9-8dca-d706d274553f.webp",
        "width": 1600,
        "height": 2000
      },
      "poi_business_url": "https://qnailloungeplus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9659369617240203771&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "q-nail-lounge-",
      "poi_latitude": "40.3276863",
      "poi_longitude": "-83.7605667",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-594-1367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCdI-BBwvP4gR-6HNRX35DIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_847491d5-a855-4e40-a708-847e2dbc2950",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2232 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b5-8b76-771a-b29c-0162495248d0.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app shown on two iPhones.",
        "public_id": "019d63b5-8b76-771a-b29c-0162495248d0",
        "storage_key": "property/6767906449167358/019d63b5-8b76-771a-b29c-0162495248d0.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/oh/bellefontaine/2232-s-main-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16063543327234501745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "40.32905960000001",
      "poi_longitude": "-83.76192209999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-599-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7As8okvP4gRcazoPYwr7d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_dcaf5724-bff6-48b6-979a-b0d41f0a6c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Relax Nail Bar + Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "130 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Relaxed locale for manicures, pedicures and haircuts plus other beauty treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-105a-721e-bdc0-d91454f0695b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-105a-721e-bdc0-d91454f0695b",
        "storage_key": "property/6767906449167358/019d7919-105a-721e-bdc0-d91454f0695b.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.relaxnbs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11897896587662603646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "relax-nail-bar--salon",
      "poi_latitude": "40.3613361",
      "poi_longitude": "-83.7610115",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-404-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wmgyTAvP4gRfjX2oejRHaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_47cda10e-68a5-4555-bbf5-8d025b0102d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Gloria's Tumbling",
      "poi_type": "Health and Wellness",
      "poi_address": "320 Co Rd 11, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-2b1c-72fe-88e4-2cc648ac5f0b.webp",
      "poi_featured_image_media": {
        "alt_text": "Gloria's Tumbling logo sign on a white building.",
        "public_id": "019d63b6-2b1c-72fe-88e4-2cc648ac5f0b",
        "storage_key": "property/6767906449167358/019d63b6-2b1c-72fe-88e4-2cc648ac5f0b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7623956660235622779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glorias-tumbling",
      "poi_latitude": "40.3480002",
      "poi_longitude": "-83.7668453",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-441-8365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1a11-701e-9ae3-9fff80be5eda.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b8-1a11-701e-9ae3-9fff80be5eda",
        "storage_key": "property/6767906449167358/019d63b8-1a11-701e-9ae3-9fff80be5eda.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrb0ZrYElP4gRe1lRZDC8zWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4b8e8eae-0c64-4597-97ef-ba8f89c8a07d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "King of Kingz barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "142 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Self-proclaimed barber shop offering haircuts for all ages and hair types.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b5-bc3e-74ce-91d8-8659e6caa6f2.webp",
      "poi_featured_image_media": {
        "alt_text": "Man with a fade haircut with spiky top",
        "public_id": "019d63b5-bc3e-74ce-91d8-8659e6caa6f2",
        "storage_key": "property/6767906449167358/019d63b5-bc3e-74ce-91d8-8659e6caa6f2.webp",
        "width": 506,
        "height": 702
      },
      "poi_business_url": "http://book.thecut.co/Mateo-Rosales-mrjf6ae",
      "poi_directions_map_url": "https://maps.google.com/?cid=2834546818756338997&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-of-kingz-barbershop",
      "poi_latitude": "40.3614898",
      "poi_longitude": "-83.76134909999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-876-8090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zvPV8wvP4gRNWUvR1BVVic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_0159f603-38df-4502-a73b-471da5c843d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Nail Box",
      "poi_type": "Health and Wellness",
      "poi_address": "2115 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Nail salon offering manicures, pedicures, waxing, eyelash extensions, and facials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019dbbc7-578c-733d-9b17-85163fc2a8da.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman's hands with decorative black and white nail art.",
        "public_id": "019dbbc7-578c-733d-9b17-85163fc2a8da",
        "storage_key": "property/6767906449167358/019dbbc7-578c-733d-9b17-85163fc2a8da.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://nailboxbellefrontaine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13556047320038977920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nail-box",
      "poi_latitude": "40.331077",
      "poi_longitude": "-83.7591904",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-210-5224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3szzpUvP4gRgDFP7TbBILw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_e2c376cf-5c60-41ae-85d0-ac52182428dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Mary Rutan Hospital - Mary Rutan Health",
      "poi_type": "Health and Wellness",
      "poi_address": "205 E Palmer Rd, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b5-d30b-757c-9f0d-65eeeb5d77e1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a mix of white and glass facade.",
        "public_id": "019d63b5-d30b-757c-9f0d-65eeeb5d77e1",
        "storage_key": "property/6767906449167358/019d63b5-d30b-757c-9f0d-65eeeb5d77e1.webp",
        "width": 592,
        "height": 333
      },
      "poi_business_url": "https://www.maryrutan.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2944393088354402656&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mary-rutan-hospital---mary-rutan-health",
      "poi_latitude": "40.3694411",
      "poi_longitude": "-83.75586969999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 937-592-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-65d41289587e.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63b8-1ad9-751d-b537-65d41289587e",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-65d41289587e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQy_E1wvP4gRYMF67umV3Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3cbc7b25-7229-49e9-83a3-27a21bc2db6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Community Health and Wellness Partners - Bellefontaine",
      "poi_type": "Health and Wellness",
      "poi_address": "212 E Columbus Ave Suite 1, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-16e3-7557-aa84-394b002e1682.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Community Health & Wellness Partners building with snow on the ground and a cloudy sky.",
        "public_id": "019d63b6-16e3-7557-aa84-394b002e1682",
        "storage_key": "property/6767906449167358/019d63b6-16e3-7557-aa84-394b002e1682.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://chwpcares.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756942514475327098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "community-health-and-wellness-partners---bellefontaine",
      "poi_latitude": "40.3607477",
      "poi_longitude": "-83.7568172",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-599-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-65d41289587e.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63b8-1ad9-751d-b537-65d41289587e",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-65d41289587e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3luyBovP4gRel7RFdLohnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_ff099db0-0678-468d-8106-ac8dfae82bed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Lions Club Ball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "576 Township Rd 174, West Liberty, OH 43357, USA",
      "poi_short_description": "Family-friendly park featuring ball diamond areas, a splash pad and a creek.",
      "poi_long_description": "People say this park offers a splash pad, playground, ball fields, and a walking track. They highlight the park is well-maintained, family-friendly, and has a fun, old-school vibe. They also like the clean restrooms and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-1a03-721c-81a7-d107780dd3be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-1a03-721c-81a7-d107780dd3be",
        "storage_key": "property/6767906449167358/019d7919-1a03-721c-81a7-d107780dd3be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westlibertylions.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1206427507496786416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lions-club-ball-park",
      "poi_latitude": "40.2542274",
      "poi_longitude": "-83.74581049999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019d63b8-1ade-7437-a9a3-9c250e0d9e62",
        "storage_key": "property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRapRDY4wP4gR8BmbF20XvhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e26eeb55-258e-47eb-8460-6c21e327eb69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Kamp A-Lott",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1888 County Hwy 25 S, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park with a playground, pool, and community center, as well as ATV rentals and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-2841-750d-be23-6aaacda35754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-2841-750d-be23-6aaacda35754",
        "storage_key": "property/6767906449167358/019d7919-2841-750d-be23-6aaacda35754.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kampalott.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1780333791235668114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kamp-a-lott",
      "poi_latitude": "40.3515472",
      "poi_longitude": "-83.67783349999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 937-599-4504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019d63b8-1ade-7437-a9a3-9c250e0d9e62",
        "storage_key": "property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyn-XicsP4gRkvg5iCYEtRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c264350a-caff-4810-ba91-7e4325fd35f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Southview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Southview Park, 601 W Lake Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park offering baseball diamonds and soccer fields, plus basketball courts, a track and playgrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-34ef-7408-b178-973738c9cf81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-34ef-7408-b178-973738c9cf81",
        "storage_key": "property/6767906449167358/019d7919-34ef-7408-b178-973738c9cf81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9839765159835388574&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southview-park",
      "poi_latitude": "40.3444633",
      "poi_longitude": "-83.7718191",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-592-3475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019d63b8-1ade-7437-a9a3-9c250e0d9e62",
        "storage_key": "property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKU4bE3glP4gRnspAkUfejYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3a4ceeed-6852-4837-bad8-e79d96f5ccae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Kaliedoscope Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401-429 E Williams Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Recreational area with a playground, picnic tables, basketball and tennis courts, and disc golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-34a9-73e4-9591-88cf050d65ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-34a9-73e4-9591-88cf050d65ef",
        "storage_key": "property/6767906449167358/019d7919-34a9-73e4-9591-88cf050d65ef.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12890887041243194454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaliedoscope-park",
      "poi_latitude": "40.3666376",
      "poi_longitude": "-83.7500201",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019d63b8-1ade-7437-a9a3-9c250e0d9e62",
        "storage_key": "property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaR25EIvP4gRVqT8FHeh5bI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4ccd0e2c-69c9-4c39-b13c-61b6a87d23c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Lewis Ratleff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 S Springhill St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park, playground, and baseball field at which kids can play games and have fun.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-37e0-7565-9c4e-9bf3ff8f8f7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-37e0-7565-9c4e-9bf3ff8f8f7a",
        "storage_key": "property/6767906449167358/019d7919-37e0-7565-9c4e-9bf3ff8f8f7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17158852839965938738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lewis-ratleff-park",
      "poi_latitude": "40.3588008",
      "poi_longitude": "-83.77606709999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019d63b8-1ade-7437-a9a3-9c250e0d9e62",
        "storage_key": "property/6767906449167358/019d63b8-1ade-7437-a9a3-9c250e0d9e62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zyLBmklP4gRMlRfF799IO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_477e8d05-46a4-4c20-811a-0fded874fdcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Bellefontaine Regional Airport-EDJ",
      "poi_type": "Transportation & Transit",
      "poi_address": "3100 OH-47, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b6-a458-730a-b62b-ade1ab8d34b7.webp",
      "poi_featured_image_media": {
        "alt_text": "Man posing with a small airplane on the tarmac.",
        "public_id": "019d63b6-a458-730a-b62b-ade1ab8d34b7",
        "storage_key": "property/6767906449167358/019d63b6-a458-730a-b62b-ade1ab8d34b7.webp",
        "width": 1414,
        "height": 743
      },
      "poi_business_url": "http://www.ci.bellefontaine.oh.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11221199920485297547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellefontaine-regional-airport-edj",
      "poi_latitude": "40.37015170000001",
      "poi_longitude": "-83.81766909999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-593-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1b4d-75f9-83e0-c2102739c543.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d63b8-1b4d-75f9-83e0-c2102739c543",
        "storage_key": "property/6767906449167358/019d63b8-1b4d-75f9-83e0-c2102739c543.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_KrbDkkP4gRi-0qDuC1uZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8b0fe664-ec27-4394-abd8-4efa4cd19056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Thermoid",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 W Sandusky Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-3de7-77aa-a869-fc1a71fc2543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-3de7-77aa-a869-fc1a71fc2543",
        "storage_key": "property/6767906449167358/019d7919-3de7-77aa-a869-fc1a71fc2543.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thermoid.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12020562900511707913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thermoid",
      "poi_latitude": "40.3609161",
      "poi_longitude": "-83.78540029999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-543-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYd90mJUlP4gRCVM9NUWe0aY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_272ae443-f83b-46cc-af2b-c67da275a178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "poi_name": "Nash Finch Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4067 Co Rd 130, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7919-42ce-7207-b199-362cb3430b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7919-42ce-7207-b199-362cb3430b47",
        "storage_key": "property/6767906449167358/019d7919-42ce-7207-b199-362cb3430b47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15780887490613963351&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nash-finch-co",
      "poi_latitude": "40.4095802",
      "poi_longitude": "-83.8028411",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 419-995-2024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b8-1ad9-751d-b537-6939c90f5616",
        "storage_key": "property/6767906449167358/019d63b8-1ad9-751d-b537-6939c90f5616.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyHBmGAmP4gRV2pz3o_5ANs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_415e8e6b-5970-4866-a118-006aca4fc2e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_8ae6b94b-e373-4761-a295-e955f78cb258",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7ff22d34-93be-4fad-957e-1e4d868ba16c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_91ae1d8e-a45a-4f50-b8fd-f44e0dea6222",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_aebbaead-7551-4654-a2e6-5dfd809b1f69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c7af213b-60a5-40c1-8550-1c660717ff77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "rating": "5.0",
      "name": "Mohana Chandaka",
      "text": "Wonderful service , got my rental application expedited and had me setup within a couple days . Really amazing service by Olivia Barhost . I definitely recommend the appartments to anyone in town.",
      "date": "2025-12-10",
      "title": ""
    },
    {
      "id": "custom_4292b735-8b8f-4499-b3cb-87b739832173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "rating": "5.0",
      "name": "Brit Myers-Eaton",
      "text": "The management here are amazing even after my first look at an apartment here they just lured me in with kindness. They worked with my husband and I to relocate to their sister apartments in Marysville with a breeze! This place is amazing, clean everything moving in. We had a 2 bedroom 2 bath on the top level out looking the wooded area. During the winter is was amazing just to be in our front room and look out our window at the beautiful snow and deer running through. Walking pets outside was a breeze. The amenities were clean, up to date. The neighbors we had were also very amazing as well. Gas/electric/water was very affordable as well. It is a bit of a drive if you work out of town, but worth the drive every day for the price of everything.",
      "date": "2015-02-16",
      "title": ""
    },
    {
      "id": "custom_215cd721-fcb2-412c-843c-0dc5be8e9030",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "rating": "5.0",
      "name": "Roger Winegardner",
      "text": "Vicky has helped the transition of moving alot less stressful. She has went out of her way to take care of needs we had to make moving in easier. Nate has been great were probably to picky when it comes to our apartment ,he has fixed about anything that we have mentioned.,mostly small details. We really appreciate everything they have done for us.",
      "date": "2021-11-06",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-7cb1-7089-afa0-ad256a01a070",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "hpa---highpoint-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358"
    },
    {
      "lead_collector_id": "019e1ddc-7d27-7604-8d24-b73d33368fce",
      "lead_source": "FACEBOOK_ADS",
      "name": "hpa---highpoint-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358"
    },
    {
      "lead_collector_id": "019e1ddc-7d9c-77d7-8b24-13d131a1c012",
      "lead_source": "LANDING_PAGE",
      "name": "hpa---highpoint-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-bellefontaine-oh",
      "search_query": "pet friendly apartments Bellefontaine OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Bellefontaine",
      "h2_subtitle": "Discover pet-friendly living in Bellefontaine, OH. Highpoint Apartments welcomes pets and offers a dedicated dog park.",
      "page_copy": "Finding the perfect pet-friendly apartment in Bellefontaine, OH has never been easier. At Highpoint Apartments, we understand how important pets are to your family. That’s why we offer a spacious, fenced-in dog park, allowing your furry friends to enjoy the outdoors in a safe and enjoyable space. Located in the serene Ohio South Area, our community is designed with your pet's happiness in mind.\n\nThe moment you step into Highpoint Apartments, you'll experience a welcoming atmosphere that caters to both you and your pets. Our selection of one, two, and three-bedroom floor plans is accompanied by modern amenities such as central heating and air conditioning. Coupled with flexible rent payments and responsive maintenance services, our pet-friendly community is the ideal choice for you and your pets. Discover your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Bellefontaine, OH",
      "seo_description": "Explore pet-friendly apartments in Bellefontaine, OH. Highpoint Apartments offers a dog park and spacious living. Find your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-logan-county",
      "search_query": "apartments with air conditioning Logan County",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning",
      "h2_subtitle": "Enjoy comfortable living in Logan County. Highpoint Apartments offer modern central heat and air conditioning units.",
      "page_copy": "Looking for apartments with air conditioning in Logan County? Highpoint Apartments in Bellefontaine, OH, have got you covered. Our residence offers modern central heat and air conditioning in each of our spacious one, two, and three-bedroom floor plans, ensuring that you live in comfort no matter the season. Nestled within the peaceful Ohio South Area, our community combines convenience and tranquility.\n\nHighpoint Apartments are designed with modern living in mind, featuring amenities like flexible rent payments and 24-hour emergency maintenance. Enjoy the benefits of a serene environment with the conveniences of contemporary upgrades. Whether you're relaxing at home or taking your furry friend to our fenced dog park, experience the ease of tailored living with air conditioning that keeps you cool and comfortable all year round.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Logan County",
      "seo_description": "Discover comfortable living with air-conditioned apartments in Logan County at Highpoint Apartments. Enjoy modern amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "dog-park-apartments-bellefontaine-43311",
      "search_query": "dog park apartments Bellefontaine 43311",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Bellefontaine",
      "h2_subtitle": "Find apartments with a dog park in Bellefontaine 43311. Highpoint Apartments offers a fenced dog park for your pets.",
      "page_copy": "Searching for dog park apartments in Bellefontaine, 43311? Look no further than Highpoint Apartments. Our pet-friendly community features a fenced dog park, providing a delightful space for your dog to play and socialize. Situated in the tranquil Ohio South Area, our living spaces are designed to accommodate both you and your pets.\n\nHighpoint Apartments offers one, two, and three-bedroom layouts, ensuring plenty of room for you and your furry companions. With amenities like flexible rent payments and modern central heat and air conditioning, our community stands out as a convenient and comfortable choice in Logan County. Experience the balance between modern living and a pet-friendly environment at Highpoint Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Bellefontaine 43311",
      "seo_description": "Discover pet-friendly living with a dog park at Highpoint Apartments in Bellefontaine, 43311. Ideal for both you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-with-upgraded-kitchens-ohio-south-area",
      "search_query": "apartments with upgraded kitchens Ohio South Area",
      "category": "Amenity",
      "h1_title": "Apartments with Upgraded Kitchens",
      "h2_subtitle": "Experience modern living in the Ohio South Area. Highpoint Apartments offer upgraded kitchens for enhanced comfort.",
      "page_copy": "Are you seeking apartments with upgraded kitchens in the Ohio South Area? Highpoint Apartments in Bellefontaine, OH, offers just what you need. Our spacious one, two, and three-bedroom floor plans feature modernized kitchen spaces designed to enhance your living experience. Located in a serene wooded setting, our community seamlessly melds modern amenities with natural beauty.\n\nIn addition to upgraded kitchens, Highpoint Apartments provides amenities such as central heat and air conditioning and a fenced dog park. We believe in making life convenient, which is why we offer flexible rent payments and responsive maintenance services around the clock. Highpoint is not just a place to live; it’s a community tailored to fit a modern lifestyle. Discover the comfort and convenience of our upgraded kitchens today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Upgraded Kitchens in Ohio South",
      "seo_description": "Find apartments with upgraded kitchens in the Ohio South Area at Highpoint Apartments. Enjoy modern living in a serene setting today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "24-hour-maintenance-apartments-bellefontaine",
      "search_query": "24 hour maintenance apartments Bellefontaine",
      "category": "Amenity",
      "h1_title": "24-Hour Maintenance Apartments",
      "h2_subtitle": "Enjoy peace of mind with 24-hour maintenance at Highpoint Apartments in Bellefontaine. Your home, our priority.",
      "page_copy": "Looking for 24-hour maintenance apartments in Bellefontaine? Highpoint Apartments is here to provide you with round-the-clock service, ensuring that any issue is addressed promptly. Nestled in the tranquil Ohio South Area, our community offers spacious one, two, and three-bedroom layouts designed for modern living.\n\nAt Highpoint Apartments, we prioritize your comfort with amenities that include central heat and air conditioning, a fenced dog park, and flexible rent payments. Our dedicated maintenance team is always ready to assist, guaranteeing peace of mind and an exceptional living experience. Discover the convenience of reliable service and modern amenities at Highpoint Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Maintenance Apartments in Bellefontaine",
      "seo_description": "Find peace of mind with 24-hour maintenance at Highpoint Apartments in Bellefontaine. Enjoy modern living with reliable service.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-bellefontaine-oh",
      "search_query": "one bedroom apartments bellefontaine oh",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Bellefontaine",
      "h2_subtitle": "Discover cozy one-bedroom apartments at Highpoint in Bellefontaine, OH. Modern living in a serene setting.",
      "page_copy": "Searching for the perfect one-bedroom apartment in Bellefontaine, OH? Highpoint Apartments offers spacious one-bedroom layouts tailored to meet your needs. Nestled within the picturesque Ohio South Area, our community blends comfort with modern amenities, such as central heating and air conditioning, to enhance your lifestyle.\n\nHighpoint Apartments isn't just about comfortable living spaces; we offer flexible rent payments and amenities like a fenced dog park to cater to your pet-friendly needs. Experience a harmonious blend of convenience and tranquility with our one-bedroom offerings. Explore Highpoint Apartments today and find the perfect home in Bellefontaine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Bellefontaine, OH",
      "seo_description": "Find cozy one-bedroom apartments at Highpoint in Bellefontaine, OH. Enjoy modern amenities in a serene setting today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-ohio-south-area",
      "search_query": "two bedroom apartments ohio south area",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Ohio South",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Highpoint in the Ohio South Area. A perfect blend of comfort and convenience awaits.",
      "page_copy": "Looking for two-bedroom apartments in the Ohio South Area? Highpoint Apartments offers generous two-bedroom floor plans ideal for those seeking extra space and modern comforts. Located in Bellefontaine, OH, our community provides a serene wooded setting combined with a host of amenities, including central heating and air conditioning, and a fenced-in dog park for pet lovers.\n\nAt Highpoint Apartments, we are dedicated to providing you with a hassle-free living experience. Enjoy flexible rent payments and 24-hour emergency maintenance, ensuring that your needs are always met. Whether you're starting fresh or need a change, our two-bedroom apartments offer the perfect blend of style, comfort, and convenience in the Ohio South Area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Ohio South Area",
      "seo_description": "Discover spacious two-bedroom apartments at Highpoint in the Ohio South Area. Experience comfort and modern living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-logan-county",
      "search_query": "three bedroom apartments logan county",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Apartments in Logan County",
      "h2_subtitle": "Spacious three-bedroom apartments available at Highpoint in Logan County. Perfect for those seeking comfort and convenience.",
      "page_copy": "Searching for three-bedroom apartments in Logan County? Highpoint Apartments in Bellefontaine is your ideal destination. Our expansive three-bedroom floor plans are designed to accommodate those needing extra space. Set against the serene backdrop of the Ohio South Area, our community combines tranquility with modern living.\n\nEnjoy a host of benefits including central heating and air conditioning, flexible rent payments, and a fenced dog park for our pet-friendly residents. Plus, with 24-hour emergency maintenance, you can live worry-free. Embrace comfort and convenience in Logan County with our three-bedroom offerings at Highpoint Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments in Logan County",
      "seo_description": "Find spacious three-bedroom apartments at Highpoint in Logan County. Enjoy comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-bellefontaine-high-school-ohio",
      "search_query": "apartments near bellefontaine high school ohio",
      "category": "School",
      "h1_title": "Apartments Near Bellefontaine High School",
      "h2_subtitle": "Discover ideal apartments near Bellefontaine High School, OH at Highpoint. Live close to education and enjoy modern amenities.",
      "page_copy": "If you're looking for apartments near Bellefontaine High School, OH, Highpoint Apartments presents an excellent choice. Our community offers a selection of one, two, and three-bedroom apartments just a short drive from the school. Enjoy the convenience of being near educational facilities while relishing in a peaceful and picturesque setting.\n\nAt Highpoint Apartments, we ensure you have everything you need for a comfortable lifestyle. Benefit from our modern amenities like central heating and air conditioning, flexible rent payment options, and our pet-friendly environment featuring a fenced dog park. Make Highpoint your new home and enjoy living within close proximity to Bellefontaine High School and all that Bellefontaine has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellefontaine High School, OH",
      "seo_description": "Live near Bellefontaine High School, OH with Highpoint Apartments. Explore our modern amenities and convenient location today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-close-to-bellefontaine-middle-school-logan-county",
      "search_query": "apartments close to bellefontaine middle school logan county",
      "category": "School",
      "h1_title": "Apartments Near Bellefontaine Middle School",
      "h2_subtitle": "Find convenient apartments close to Bellefontaine Middle School, centrally located in Logan County at Highpoint Apartments.",
      "page_copy": "Looking for the perfect apartments close to Bellefontaine Middle School in Logan County? Highpoint Apartments offers you an incredible living experience just minutes away. Nestled in a tranquil community, our spacious one, two, and three-bedroom floor plans are perfect for those seeking proximity to educational institutions.\n\nEnjoy modern conveniences and a host of amenities such as central heating and air conditioning, flexible rent payments, and a pet-friendly environment with a fenced dog park. In addition, our 24-hour emergency maintenance service ensures you can live worry-free. Choose Highpoint Apartments in Logan County for a blend of comfort, convenience, and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellefontaine Middle School",
      "seo_description": "Explore Highpoint Apartments, near Bellefontaine Middle School in Logan County. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-southeastern-elementary-school-bellefontaine",
      "search_query": "apartments near southeastern elementary school bellefontaine",
      "category": "School",
      "h1_title": "Apartments Near Southeastern Elementary School",
      "h2_subtitle": "Explore living options near Southeastern Elementary School in Bellefontaine. Highpoint Apartments offers the perfect location.",
      "page_copy": "If proximity to Southeastern Elementary School is on your checklist, Highpoint Apartments in Bellefontaine should be your next home. With spacious one, two, and three-bedroom options, our community provides a perfect balance of location and lifestyle, making daily school commutes a breeze.\n\nHighpoint Apartments offers unparalleled amenities, including a fenced dog park and flexible rent payment solutions. Our central heating and air conditioning systems ensure comfort all year round. Positioned in a serene wooded setting, residents can enjoy a peaceful living environment with modern conveniences just minutes away from Southeastern Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southeastern Elementary School",
      "seo_description": "Discover Highpoint Apartments near Southeastern Elementary School, Bellefontaine. Ideal location with modern amenities and peaceful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-close-to-western-elementary-school-bellefontaine-oh",
      "search_query": "apartments close to western elementary school bellefontaine oh",
      "category": "School",
      "h1_title": "Apartments Near Western Elementary Bellefontaine",
      "h2_subtitle": "Discover apartments close to Western Elementary School in Bellefontaine, OH. Experience convenience and community at Highpoint Apartments.",
      "page_copy": "Highpoint Apartments in Bellefontaine, OH, provides the perfect home base for those seeking apartments close to Western Elementary School. Our spacious one, two, and three-bedroom floor plans ensure a comfortable setting just minutes from the school, allowing you to enjoy proximity and convenience.\n\nOur community prides itself on offering top-notch amenities such as a fenced dog park, ideal for pet owners, and flexible rent payment options. With central heating and air conditioning, our comfortable homes meet all your climate needs. Experience the quiet beauty of our wooded surroundings while staying connected to important local education facilities like Western Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Western Elementary Bellefontaine",
      "seo_description": "Find your home at Highpoint Apartments near Western Elementary School, Bellefontaine, OH. Convenient location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-benjamin-logan-high-school-ohio-43311",
      "search_query": "apartments near benjamin logan high school ohio 43311",
      "category": "School",
      "h1_title": "Apartments Near Benjamin Logan High School",
      "h2_subtitle": "Discover convenient living with apartments near Benjamin Logan High School in Ohio, 43311. Highpoint Apartments offer ideal homes for you.",
      "page_copy": "Searching for apartments near Benjamin Logan High School in Ohio, 43311? Highpoint Apartments is your go-to choice, providing spacious one, two, and three-bedroom floor plans tailored for comfort and convenience. Ideally located just a short drive away, our community ensures easy access to the school.\n\nExperience the best of apartment living with our assortment of modern amenities, including a fenced dog park and flexible rent payment plans. Each home is equipped with central heating and air conditioning, ensuring a comfortable environment year-round. At Highpoint Apartments, residents enjoy a serene wooded backdrop, contributing to a peaceful and welcoming atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Benjamin Logan High School",
      "seo_description": "Explore Highpoint Apartments near Benjamin Logan High School, Ohio 43311. Enjoy a convenient location and modern amenities ideal for you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-close-to-calvary-christian-school-logan-county",
      "search_query": "apartments close to calvary christian school logan county",
      "category": "School",
      "h1_title": "Apartments Near Calvary Christian School",
      "h2_subtitle": "Looking for a home near Calvary Christian School in Logan County? Highpoint Apartments offers the perfect blend of location and comfort.",
      "page_copy": "Highpoint Apartments is ideally situated for those seeking apartments close to Calvary Christian School in Logan County. Our community offers spacious one, two, and three-bedroom floor plans that cater to various living needs, ensuring a convenient commute for you.\n\nResidents at Highpoint Apartments enjoy modern amenities, such as flexible rent payments and a pet-friendly fenced dog park. With central heating and air conditioning, each apartment provides a comfortable living environment year-round. Nestled in a serene wooded setting, our community combines tranquility with accessibility, making it an excellent choice for those wanting to be connected to Calvary Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Calvary Christian School",
      "seo_description": "Discover Highpoint Apartments near Calvary Christian School in Logan County. Enjoy convenience and comfort in a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-ohio-hi-point-career-center-ohio-south-area",
      "search_query": "apartments near ohio hi-point career center ohio south area",
      "category": "School",
      "h1_title": "Apartments Near Ohio Hi-Point Career Center",
      "h2_subtitle": "Discover ideal living with apartments near the Ohio Hi-Point Career Center in the Ohio South Area. Experience comfort at Highpoint Apartments.",
      "page_copy": "Highpoint Apartments offers exceptional living for those looking to reside near the Ohio Hi-Point Career Center in the Ohio South Area. Our community features spacious one, two, and three-bedroom floor plans, designed with your comfort in mind, and is situated just a short distance from the career center.\n\nEnjoy a comprehensive list of amenities, including central heat and air conditioning for year-round comfort, a fenced-in dog park for pet lovers, and flexible rent payments to accommodate diverse lifestyles. The serene wooded location provides a peaceful atmosphere, making Highpoint Apartments a prime choice for those connected to the Ohio Hi-Point Career Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ohio Hi-Point Career Center",
      "seo_description": "Explore Highpoint Apartments near Ohio Hi-Point Career Center. Find comfort and convenience in the Ohio South Area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-mary-rutan-hospital-bellefontaine",
      "search_query": "apartments near Mary Rutan Hospital Bellefontaine",
      "category": "Hospital",
      "h1_title": "Apartments Near Mary Rutan Hospital",
      "h2_subtitle": "Find your ideal home with apartments near Mary Rutan Hospital in Bellefontaine. Discover Highpoint Apartments' perfect location and amenities.",
      "page_copy": "Highpoint Apartments are conveniently located near Mary Rutan Hospital in Bellefontaine, making them an excellent choice for those seeking nearby accommodations. Our community offers diverse one, two, and three-bedroom floor plans, all designed with comfort and convenience in mind.\n\nResidents benefit from a variety of amenities, such as a fenced dog park ideal for pet owners, flexible rent payment options, and central heating and air conditioning for a comfortable environment. Set within a serene wooded landscape, Highpoint Apartments provide the perfect retreat while maintaining proximity to Mary Rutan Hospital, ensuring a balanced living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mary Rutan Hospital",
      "seo_description": "Discover comfortable living at Highpoint Apartments near Mary Rutan Hospital in Bellefontaine. Enjoy a convenient location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-kaliedoscope-park-bellefontaine-oh",
      "search_query": "apartments near Kaliedoscope Park Bellefontaine OH",
      "category": "Park",
      "h1_title": "Apartments Near Kaliedoscope Park",
      "h2_subtitle": "Find perfect homes near Kaliedoscope Park in Bellefontaine, OH. Highpoint Apartments offers ideal proximity and modern amenities.",
      "page_copy": "Highpoint Apartments is the perfect choice for those seeking apartments near Kaliedoscope Park in Bellefontaine, OH. With spacious one, two, and three-bedroom floor plans, our community caters to diverse living preferences, offering convenience and comfort close to this popular recreational area.\n\nOur residents enjoy numerous amenities, including a fenced-in dog park for pet-friendly living, flexible rent payment options, and central heating and air conditioning for year-round comfort. Nestled in a peaceful wooded setting, Highpoint Apartments provides a serene living environment while being just minutes away from the fun and attraction of Kaliedoscope Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kaliedoscope Park, OH",
      "seo_description": "Explore Highpoint Apartments near Kaliedoscope Park in Bellefontaine, OH. Enjoy comfort and convenience in a serene setting with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-close-to-jack-martin-park-logan-county",
      "search_query": "apartments close to Jack Martin Park Logan County",
      "category": "Park",
      "h1_title": "Apartments Near Jack Martin Park",
      "h2_subtitle": "Enjoy convenient living near Jack Martin Park in Logan County. Discover the charm of Highpoint Apartments.",
      "page_copy": "Highpoint Apartments provides an ideal living space for those seeking residences close to Jack Martin Park in Logan County. Our range of one, two, and three-bedroom floor plans is perfect for those desiring proximity to this beautiful park.\n\nLife at Highpoint Apartments offers more than just a prime location. With amenities like a fenced dog park, flexible rent payments, and central heating and air, you'll experience comfort and convenience in a serene wooded environment. Highpoint Apartments combines modern living with easy access to Jack Martin Park, making it a desirable choice for nature enthusiasts and park-goers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Jack Martin Park",
      "seo_description": "Highpoint Apartments near Jack Martin Park in Logan County offers modern living in a serene setting with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-blue-jacket-park-ohio-south-area",
      "search_query": "apartments near Blue Jacket Park Ohio South Area",
      "category": "Park",
      "h1_title": "Apartments Near Blue Jacket Park",
      "h2_subtitle": "Discover great living near Blue Jacket Park in the Ohio South Area. Explore the benefits of Highpoint Apartments today.",
      "page_copy": "Highpoint Apartments are ideally located for those seeking a home near Blue Jacket Park in the Ohio South Area. Our spacious one, two, and three-bedroom floor plans are designed to accommodate a variety of living needs, providing easy access to this local gem.\n\nResidents of Highpoint Apartments enjoy amenities that enhance their lifestyle, including a fenced dog park for our furry friends, flexible rent payment options, and climate control with central heat and air. Nestled in a tranquil wooded environment, our community offers a peaceful retreat while keeping you close to the outdoor fun and activities at Blue Jacket Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blue Jacket Park, OH",
      "seo_description": "Find your new home at Highpoint Apartments near Blue Jacket Park in Ohio South Area, offering comfortable living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "bellefontaine-apartments-near-brown-park",
      "search_query": "Bellefontaine apartments near Brown Park",
      "category": "Park",
      "h1_title": "Bellefontaine Apartments Near Brown Park",
      "h2_subtitle": "Explore living options near Brown Park in Bellefontaine. Highpoint Apartments offers a blend of comfort and accessibility.",
      "page_copy": "For those looking for Bellefontaine apartments near Brown Park, Highpoint Apartments is the ideal choice. We offer a selection of spacious one, two, and three-bedroom floor plans designed to suit a range of living needs and preferences.\n\nOur community boasts excellent amenities such as a fenced dog park, flexible rent payment options, and central heating and air conditioning, all set in a serene, wooded backdrop. With Brown Park just a short distance away, Highpoint Apartments ensures you enjoy both a peaceful home and proximity to one of Bellefontaine's favorite recreational spots.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bellefontaine Apartments Near Brown Park",
      "seo_description": "Choose Highpoint Apartments near Brown Park in Bellefontaine for a blend of convenience and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-close-to-lewis-ratleff-park-43311",
      "search_query": "apartments close to Lewis Ratleff Park 43311",
      "category": "Park",
      "h1_title": "Apartments Close to Lewis Ratleff Park",
      "h2_subtitle": "Find comfort and convenience near Lewis Ratleff Park. Highpoint Apartments offers prime location in the 43311 area.",
      "page_copy": "Highpoint Apartments offers the perfect home for those seeking proximity to Lewis Ratleff Park in the 43311 area. Our community provides a variety of spacious one, two, and three-bedroom floor plans that align with diverse lifestyles.\n\nLiving at Highpoint means you'll enjoy amenities like a fenced-in dog park and flexible rent payment options, all within a peaceful, wooded setting. Central heating and air conditioning add to your comfort, while the nearness to Lewis Ratleff Park makes it easy to enjoy outdoor activities. Discover how Highpoint Apartments perfectly balances modern living and nature access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis Ratleff Park, 43311",
      "seo_description": "Discover Highpoint Apartments close to Lewis Ratleff Park in 43311, offering spacious living and modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167358",
      "source": "custom",
      "page_item_url": "apartments-near-fred-carter-park-oh",
      "search_query": "apartments near Fred Carter Park OH",
      "category": "Park",
      "h1_title": "Apartments Near Fred Carter Park OH",
      "h2_subtitle": "Discover premium living near Fred Carter Park, OH. Highpoint Apartments offers comfort in a prime location.",
      "page_copy": "If you're searching for apartments near Fred Carter Park, OH, consider Highpoint Apartments for your new home. We offer spacious one, two, and three-bedroom options tailored to meet a variety of living needs.\n\nHighpoint Apartments provides residents with excellent amenities, including a fenced dog park and flexible rent payment plans. Our central heating and air conditioning ensure year-round comfort. Located in a serene, wooded area, this community not only offers tranquility but also easy access to Fred Carter Park, making it a preferred choice for those who enjoy outdoor activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool in the foreground.",
        "public_id": "019d7918-a4f3-7609-bf50-6d3492648559",
        "storage_key": "property/6767906449167358/019d7918-a4f3-7609-bf50-6d3492648559.webp",
        "width": 2592,
        "height": 1944
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fred Carter Park, OH",
      "seo_description": "Experience comfortable living at Highpoint Apartments near Fred Carter Park, OH, with top amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6281"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680141604"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4059830"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-THFWG87G"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58347924637"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_realpage_tour_widget",
      "type": "STRING",
      "value": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"70T4X4196420\")</script>"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJtc3lVMDd0dWFZankwbVFWRkFZdWc9PSIsInZhbHVlIjoiYlpRcTBkVDRjZHhpdGliRExZNTcvUT09IiwibWFjIjoiMDFjYWU4MzA4MDQ0ZGYwNjVjODVkMWRjMDE4MGQzMTk4ZTIzZWQ3NzUxM2NjMjExMzRiYWJkYjRmMTU4NGVmMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "6281",
  "custom_repli_id": "11680141604",
  "custom_realpage_id": "4059830",
  "custom_google_gtm_id": "GTM-THFWG87G",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Prestige",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "58347924637",
  "custom_social_subscription": "none",
  "custom_realpage_tour_widget": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"70T4X4196420\")</script>",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJtc3lVMDd0dWFZankwbVFWRkFZdWc9PSIsInZhbHVlIjoiYlpRcTBkVDRjZHhpdGliRExZNTcvUT09IiwibWFjIjoiMDFjYWU4MzA4MDQ0ZGYwNjVjODVkMWRjMDE4MGQzMTk4ZTIzZWQ3NzUxM2NjMjExMzRiYWJkYjRmMTU4NGVmMiJ9",
  "custom_audioeye_site_id": "f4f04ab4-509f-463f-91f9-adc83a850296",
  "custom_audioeye_site_hash": "f8e4d2b11a0815ea23fcea16643ecc5c"
};

export const generatedAt = '2026-10-26T16:35:56.411Z';
